import React from 'react';
import {Snackbar, IconButton,SnackbarContent } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import {green, amber, blue,red} from '@material-ui/core/colors';
import * as Actions from '../../store/actions';
import { useSelector,useDispatch } from 'react-redux';
import {makeStyles} from '@material-ui/styles';
import clsx from 'clsx';

const useStyles = makeStyles(theme => ({
  root   : {},
  success: {
      backgroundColor: green[600],
      color          : '#FFFFFF'
  },
  error  : {
      backgroundColor: red[600],
      color          : '#FFFFFF'
  },
  info   : {
      backgroundColor: blue[600],
      color          : '#FFFFFF'
  },
  warning: {
      backgroundColor: amber[600],
      color          : '#FFFFFF'
  }
}));


function AlertSnackbar(props)
{
  useSelector(({register}) => register);
  const state = useSelector(({register}) => register.message.state);
  const options = useSelector(({register}) => register.message.options);
  const message = useSelector(({register}) => register.message);
  const dispatch = useDispatch();
  const classes = useStyles();

  const handleClose = () => {
      
      if(state){
          setTimeout(() => {
            dispatch(Actions.hideMessage());
          }, 6000);
      }
    
  };
  
 
  return (

    <Snackbar
            {...options}
            open={state}
            onClose={() => handleClose()}
            classes={{
                root: classes.root
            }}
            ContentProps={{
                variant        : 'body2',
                headlineMapping: {
                    body1: 'div',
                    body2: 'div'
                }
            }}
        >
            <SnackbarContent
                className={clsx(classes[options.variant])}
                message={message.options.message}
                action={
                        <React.Fragment>
                          <IconButton size="small" aria-label="close" color="inherit" onClick={() => dispatch(Actions.hideMessage())}>
                            <CloseIcon fontSize="small" />
                          </IconButton>
                        </React.Fragment>
                      }
            />
        </Snackbar>
    
  );

}

export default AlertSnackbar;
